<section id="content" class="audit-view" *ngIf="this.lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang?.audit_view}}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.Servicing_List">{{lang?.audit_view}}</a>
          </li>
        </ul>

        <div style="float: right;">
          <div class="social-icons">
            <a class="plus-vdead" (click)="viewServicing()"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-list"></i>
            </a>

          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" [ngClass]="selectedTab === 'auditplan' ? 'active' : 'none'"><a href="#auditplanTab" aria-controls="auditplanTab" role="tab" data-toggle="tab">{{lang?.audit_details}}</a></li>

                  <li role="presentation" [ngClass]="selectedTab === 'standard' ? 'active' : 'none'"><a href="#standardTab" aria-controls="standardTab" role="tab" data-toggle="tab">{{lang?.std_clause_audit}}</a></li>

                  <li role="presentation" [ngClass]="selectedTab === 'report' ? 'active' : 'none'"><a href="#reportTab" aria-controls="reportTab"
                      role="tab" data-toggle="tab">{{lang?.report}}</a> </li>
                </ul>

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane"  [ngClass]="selectedTab === 'auditplan' ? 'active' : 'none'" id="auditplanTab">
                    <div class="wrap-reset">

                      <form class="form-validation">

                        <div class="row">

                          <div class="form-group col-sm-6">
                            <h2 class="audit-header-info">{{lang?.audit_details}}</h2>
                            <div class="form-group col-sm-6">
                              <label for="badge-number">{{ lang?.audit_num }}</label>
                              <input type="text" class="form-control" [value]="single_data?.audit_no" readonly>
                            </div>
                          
                            <div class="form-group col-sm-6">
                              <label for="factory-number">{{ lang?.std }}</label>
                              <input type="text" class="form-control" [value]="single_data?.company_contact" readonly>
                            </div>
                          
                            <div class="form-group col-sm-12">
                              <label for="badge-number">{{ lang?.description }}</label>
                              <input type="text" class="form-control" [value]="single_data?.description" readonly>
                            </div>

                            <div *ngFor="let data of single_data?.auditors">
                              <div class="form-group col-sm-6">
                                <label for="badge-number">{{ lang?.auditor }}</label>
                                <input type="text" class="form-control" [value]="data?.name" readonly>
                              </div>
                            
                              <div class="form-group col-sm-6">
                                <label for="factory-number">{{ lang?.function }}</label>
                                <input type="text" class="form-control" [value]="data?.function" readonly>
                              </div>
                            </div>
                          
                            <div class="form-group col-sm-12">
                              <label for="factory-number">{{ lang?.notes }}</label>
                              <input type="text" class="form-control" [value]="single_data?.notes" readonly>
                            </div>
                          
                            <div class="form-group col-sm-6">
                              <label for="badge-number">{{ lang?.company }}</label>
                              <input type="text" class="form-control" [value]="single_data?.company" readonly>
                            </div>

                            <div class="form-group col-sm-6">
                              <label for="badge-number">{{ lang?.address }}</label>
                              <input type="text" class="form-control" [value]="single_data?.company_address" readonly>
                            </div>                            
                          
                            <div class="form-group col-sm-6">
                              <label for="factory-number">{{ lang?.company_contact }}</label>
                              <input type="text" class="form-control" [value]="single_data?.company_contact" readonly>
                            </div>
                          
                            <div class="form-group col-sm-6">
                              <label for="badge-number">{{ lang?.iaf_main }}</label>
                              <input type="text" class="form-control" [value]="single_data?.iaf_main" readonly>
                            </div>
                          
                            <div class="form-group col-sm-12">
                              <label for="factory-number">{{ lang?.scope_of_cert }}</label>
                              <input type="text" class="form-control" [value]="single_data?.scope_of_cert" readonly>
                            </div>
                          
                            <div class="form-group col-sm-6">
                              <label for="badge-number">{{ lang?.start_date }}</label>
                              <input type="text" class="form-control" [value]="single_data?.start_date" readonly>
                            </div>
                          
                            <div class="form-group col-sm-6">
                              <label for="factory-number">{{ lang?.end_date }}</label>
                              <input type="text" class="form-control" [value]="single_data?.end_date" readonly>
                            </div>

                            <!-- Standard Clause Audited -->
                            <div class="form-group col-sm-12">
                              <label>{{ lang?.std_clause_audited }}</label>
                              <ng-multiselect-dropdown [disabled]="true" [settings]="dropdownSettings" name="std_clause_audited" [data]="dropdownList" [(ngModel)]="selDropdownList">
                              </ng-multiselect-dropdown>          
                            </div>    
                            
                            <div class="row datas-input">
                              <div class="col-xs-4 col-sm-4">
                                <label></label>
                                <button (click)="generate_report_pdf('audit_plan')" class="generate_report purple-color" id="treatment_un1" type="button"><i class="fa fa-plus pull-left" style="margin-top:4px;"></i>{{ lang?.generate_report }}</button>
                              </div>
                              <div class="col-xs-4 col-sm-4">
                                <label></label>
                                <div class="show-value">
                                   <button class="generate_report white-color" id="treatment_un1" (click)="openPDFLink()" type="button"><i class="fa fa-plus pull-left" style="margin-top:4px;"></i>{{ single_data?.audit_no }}_AUDIT_PLAN</button> 
                                </div>
                              </div>
                              <div class="col-xs-1 col-sm-1">
                                <label></label>
                                <a (click)="showMailModal('mail_plan')" class="common-newicons audit_plan_mail_click export_new" href="javascript:void(0);"
                                  style="display: inline-block;margin-top: 19px;" title="Email">
                                  <i class="fa fa-envelope" style="font-size: 35px;"></i>
                                </a>
                              </div>
                              <div class="col-xs-3 col-sm-3">
                                <label>{{lang?.delivery_status}}</label>
                                <div class="input-group">
                                  <input class="form-control" type="text" disabled="" [value]="single_data?.plan_report_delivery">
                                </div>
                              </div>
                            
                            </div>

                          </div>

                          <div class="form-group col-sm-6">
                            <div class="commnad-require">
                              <p class="quality-col1" style="width: 40%;"><span>{{lang?.requirement}}</span></p>
                              <p class="quality-col2" style="width: 11%;"><span>{{lang?.auditor}}</span></p>
                              <p class="quality-col3" style="width: 11%;"><span>{{lang?.reference}}</span></p>
                              <p class="quality-col4" style="width: 11%;"><span>{{lang?.date}}</span></p>
                              <p class="quality-col5" style="width: 11%;"><span>{{lang?.start_hour}}</span></p>
                              <p class="quality-col6" style="width: 11%;"><span>{{lang?.end_hour}}</span></p>
                              <p class="quality-col7" style="width: 5%;"><span></span></p>
                          </div>


                          <div class="ios-sections">
                            <ul>
                              <li class="data_standard" *ngFor="let standard of single_data?.output2?.standards" [attr.data-standard]="standard?.standard_id">
                                <div class="standard-values parent_iso">
                                  <p class="quality-col1" style="width: 40%;">
                                    <span class="caret" (click)="toggle($event)"> <i class="fa fa-plus" aria-hidden="true"></i></span>
                                    <strong><i class="fa fa-folder-open" aria-hidden="true"></i>
                                      {{ standard?.standard_title }}
                                    </strong>
                                  </p>
                                  <p style="width: 10%;" class="quality-col2">
                                    {{ standard?.total_weight }}
                                  </p>
                                  <p style="width: 10%;" class="quality-col3">
                                    {{ standard?.nc_count }}          
                                  </p>
                                  <p style="width: 10%;" class="quality-col4">
                                    {{ standard?.oss_count }}          
                                  </p>
                                  <p style="width: 10%;" class="quality-col5">
                                    {{ standard?.com_count }}          
                                  </p>
                                  <p class="quality-col6">
                                    {{ standard?.result_percent | number : '1.2-2' }}          
                                  </p>
                                </div>
                                <ul class="nested">
                          
                                  <li class="data_chapter" *ngFor="let chapter of standard?.chapters" [attr.data-chapter]="chapter?.chapter_id">
                                    <div class="standard-values">
                                      <p  class="quality-col1" style="width: 40%;">
                                        <span class="caret" (click)="toggle($event)"> <i class="fa fa-plus" aria-hidden="true"></i></span>
                                        <strong>
                                          {{ chapter?.chapter_no }} -  {{ chapter?.chapter_title }}
                                        </strong>
                                      </p>
                                      <p style="width: 10%;"  class="quality-col2">
                                        {{ chapter?.total_weight }}
                                      </p>
                                      <p style="width: 10%;"  class="quality-col3">
                                        {{ chapter?.nc_count }}
                                      </p>
                                      <p style="width: 10%;"  class="quality-col4">
                                        {{ chapter?.oss_count }}
                                      </p>
                                      <p style="width: 10%;"  class="quality-col5">
                                        {{ chapter?.com_count }}
                                      </p>
                                      <p style="width: 10%;"  class="quality-col6">
                                        {{ chapter?.result_percent }}
                                      </p>
                                    </div>
                                    <ul class="nested">

                                      <form class="auditing_form" *ngFor="let clause of chapter?.clauses" [attr.data-clause]="clause?.clause_id">

                                        <div class="standard-values" >
                                            <p class="quality-col1" style="width: 40%;">
                                              {{ clause?.clause_no }} - {{ clause?.clause_title }}
                                            </p>
                                            <p class="quality-col2" style="width: 11%;">
                                                <select class="form-control" required name="auditor_id" [disabled]="disableField">
                                                    <option value="">Select Auditor</option>
                                                    <option *ngFor="let auditor of single_data?.output1?.audit_details?.auditors" [selected]="getSelectedValue(clause,auditor?.auditor_id,'auditor_id')"  [value]="auditor?.auditor_id"> 
                                                      {{ auditor?.name }}
                                                    </option>
                                                </select>
                                            </p>
                                            <p class="quality-col3" style="width: 11%;">
                                                <input type="text" [disabled]="disableField" class="form-control" required name="auditing_reference" [value]="getAuditingRef(clause)">
                                            </p>
                                            <p class="quality-col4" style="width: 11%;">
                                                <input type="text" [disabled]="disableField" class="form-control datepicker" placeholder="Select Date" required name="auditing_date" [value]="getAuditingDate(clause)">
                                            </p>
                                            <p class="quality-col5" style="width: 11%;">
                                                <select class="form-control" required name="start_hour" [disabled]="disableField">
                                                  <option value="">Select Hour</option>
                                                  <option *ngFor="let hour of single_data?.time" [selected]="getSelectedValue(clause,hour,'start_hour')"  [value]="hour">
                                                    {{ hour }}
                                                  </option>
                                                </select>
                                            </p>
                                            <p class="quality-col6" style="width: 11%;">
                                              <select class="form-control" required name="end_hour" [disabled]="disableField">
                                                <option value="">Select Hour</option>
                                                <option *ngFor="let hour of single_data?.time" [selected]="getSelectedValue(clause,hour,'end_hour')"  [value]="hour">
                                                  {{ hour }}
                                                </option>
                                              </select>
                                            </p>
                                            <p class="quality-col7" style="width: 5%;">

                                                <a (click)="editReq($event)" href="javascript:void(0);" class="btn common-newicons icon-colors1 auditing_edit" title="Edit" style="padding:0;" >
                                                    <span class="glyphicon glyphicon-edit" ></span>
                                                </a>
                                                <a (click)="saveReq($event)" href="javascript:void(0);" class="btn btn-123 common-newicons icon-colors2 hide auditing_save" title="Save" style="padding:0;">
                                                    <span class="glyphicon glyphicon-floppy-disk"></span>
                                                </a>
                    
                                            </p>
                                      
                                        </div>

                                        </form>                                      
                          
                                      <!-- <div *ngFor="let clause of chapter?.clauses"  class="standard-values" [attr.data-clause]="clause?.clause_id">
                                        <p class="quality-col1 clause_action" data-action="view_clause"
                                          data-id="{{ clause?.clause_id }}">
                                          {{ clause?.clause_no }} - {{ clause?.clause_title }}
                                        </p>
                                        <p class="quality-col2">
                                          {{ clause?.total_weight }}
                                        </p>
                                        <p class="quality-col3">
                                          {{ clause?.nc_count }}
                                        </p>
                                        <p class="quality-col4">
                                          {{ clause?.nc_count }}
                                        </p>
                                        <p class="quality-col5">
                                          {{ clause?.com_count }}
                                        </p>
                                        <p class="quality-col6"></p>
                                      </div> -->
                          
                                    </ul>
                                  </li>
                          
                                </ul>
                              </li>
                          
                            </ul>
                          </div>                          
                          </div>

                        </div>
                      </form>
                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane"  [ngClass]="selectedTab === 'ord' ? 'active' : 'none'" id="standardTab">
                    <div class="row">
                      <div class="col-xs-12 col-sm-7 col-md-7 stand-rights">
                        <div class="require-column">
                            <div class="commnad-require">
                                <p class="quality-col1"><span>{{ lang?.requirement }}</span></p>
                                <p class="quality-col2"><span>{{ lang?.value }}</span></p>
                                <p class="quality-col3"><span>{{ lang?.NC }}</span></p>
                                <p class="quality-col4"><span>{{ lang?.OSS }}</span></p>
                                <p class="quality-col5"><span>{{ lang?.COM }}</span></p>
                                <p class="quality-col6"><span>{{ lang?.results }} %</span></p>
                            </div>                      
                            <div class="ios-sections">
                              <ul>
                                <li class="data_standard" *ngFor="let standard of single_data?.output2?.standards" [attr.data-standard]="standard?.standard_id">
                                  <div class="standard-values parent_iso">
                                    <p class="quality-col1" style="width: 57%;">
                                      <span class="caret" (click)="toggle($event)"> <i class="fa fa-plus" aria-hidden="true"></i></span>
                                      <strong><i class="fa fa-folder-open" aria-hidden="true"></i>
                                        {{ standard?.standard_title }}
                                      </strong>
                                    </p>
                                    <p style="width: 8%;" class="quality-col2">
                                      {{ standard?.total_weight }}
                                    </p>
                                    <p style="width: 8%;" class="quality-col3">
                                      {{ standard?.nc_count }}          
                                    </p>
                                    <p style="width: 8%;" class="quality-col4">
                                      {{ standard?.oss_count }}          
                                    </p>
                                    <p style="width: 8%;" class="quality-col5">
                                      {{ standard?.com_count }}          
                                    </p>
                                    <p class="quality-col6">
                                      {{ standard?.result_percent | number : '1.2-2' }}          
                                    </p>
                                  </div>
                                  <ul class="nested">
                            
                                    <li class="data_chapter" *ngFor="let chapter of standard?.chapters" [attr.data-chapter]="chapter?.chapter_id">
                                      <div class="standard-values">
                                        <p  class="quality-col1" style="width: 57%;">
                                          <span class="caret" (click)="toggle($event)"> <i class="fa fa-plus" aria-hidden="true"></i></span>
                                          <strong>
                                            {{ chapter?.chapter_no }} -  {{ chapter?.chapter_title }}
                                          </strong>
                                        </p>
                                        <p style="width: 8%;"  class="quality-col2">
                                          {{ chapter?.total_weight }}
                                        </p>
                                        <p style="width: 8%;"  class="quality-col3">
                                          {{ chapter?.nc_count }}
                                        </p>
                                        <p style="width: 8%;"  class="quality-col4">
                                          {{ chapter?.oss_count }}
                                        </p>
                                        <p style="width: 8%;"  class="quality-col5">
                                          {{ chapter?.com_count }}
                                        </p>
                                        <p style="width: 8%;"  class="quality-col6">
                                          {{ chapter?.result_percent }}
                                        </p>
                                      </div>
                                      <ul class="nested">
                            
                                        <div *ngFor="let clause of chapter?.clauses"  class="standard-values" [attr.data-clause]="clause?.clause_id">
                                          <p class="quality-col1 clause_action" (click)="showDocsInformation($event,clause?.clause_id)" data-action="view_clause"
                                            data-id="{{ clause?.clause_id }}">
                                            {{ clause?.clause_no }} - {{ clause?.clause_title }}
                                          </p>
                                          <p class="quality-col2">
                                            {{ clause?.total_weight }}
                                          </p>
                                          <p class="quality-col3">
                                            {{ clause?.nc_count }}
                                          </p>
                                          <p class="quality-col4">
                                            {{ clause?.nc_count }}
                                          </p>
                                          <p class="quality-col5">
                                            {{ clause?.com_count }}
                                          </p>
                                          <p class="quality-col6"></p>
                                        </div>
                            
                                      </ul>
                                    </li>
                            
                                  </ul>
                                </li>
                            
                              </ul>
                            </div>    
                          </div>
                      </div>
                      <!-- Add and edit section of clause-->
                      <div class="col-xs-12 col-sm-5 col-md-5 stand-lefts clause_manage_popup" *ngIf="docsInfo">
                        <div class="form_groups">
                        
                          <ul id="myTab4" class="nav nav-tabs tab-padding tab-space-3 tab-blue">
                            <li class="active">
                              <a href="#tab1" id="tab1_li" data-toggle="tab">{{lang?.clause}}</a>
                            </li>
                            <li>
                              <a href="#tab2" id="tab2_li" data-toggle="tab">{{lang?.evaluvation}}</a>
                            </li>
                            <li>
                              <a href="#tab3" (click)="fileDesign()" id="tab3_li" data-toggle="tab">{{lang?.documentation}}</a>
                            </li>
                          </ul>
                        
                          <!-- Tab Content -->
                        
                          <div class="tab-content">
                        
                            <!-- Tab 1 content -->
                        
                            <div class="tab-pane in active" id="tab1">
                        
                              <div class="form-group">
                                <label>{{lang?.requirement}}</label>
                                <input type="text" [value] = "docsInfo?.clause_no +'-'+  docsInfo?.clause_title" disabled="true">
                              </div>
                              <div class="form-group">
                                <label>ID #</label>
                                <input type="text" disabled="true" [value]="docsInfo?.clause_no">
                              </div>
                              <div class="form-group">
                                <label>{{lang?.name}}</label>
                                <input type="text" disabled="true" [value]="docsInfo?.clause_title">
                              </div>
                              <div class="form-group">
                                <label>{{lang?.weight}}</label>
                                <input type="text" disabled="true" [value]="docsInfo?.weight">
                              </div>
                              <div class="form-group">
                                <label>{{lang?.description}}</label>
                                <textarea rows="5" disabled>
                                  {{ docsInfo?.description }}
                                </textarea>
                              </div>
                              <div class="form-group">
                                <label>{{lang?.tip}}</label>
                                <textarea rows="5" disabled>
                                  {{ docsInfo?.tips }}
                                </textarea>
                              </div>

                              <div class="form-senders confirm-bts">
                                <input (click)="switch_tab('tab2_li')" type="button" value="Next" class="btn btn-primary save_tab" data-action="next" data-tab="tab2">
                              </div>
                        
                        
                            </div>
                        
                            <!-- Tab 2 content -->
                            <div class="tab-pane" id="tab2">
                        
                              <form id="clause_manage_form1" [formGroup]="evaluvationForm"  method="post"  class="form-horizontal" enctype="multipart/form-data" autocomplete="off">
                        
                                <div class="form-group">
                                  <label>{{lang?.notes}}</label>
                                  <textarea name="notes" formControlName="notes" rows="10"></textarea>
                                </div>
                             
                        
                                <div class="form-group">
                                  <a href="javascript:void(0);" class="pull-right common-newicons icon-colors4 remarks_action "
                                    data-action="add_remarks" (click)="newRemarks()">
                                    <span class="glyphicon glyphicon-plus"></span>
                                  </a>
                                  <label>{{lang?.add_remarks}}</label>
                                </div>

                                <div formArrayName="remarks">
                                  <div *ngFor="let remark of evaluvationForm?.get('remarks')?.controls;let i = index" [formGroupName]="i">
                                
                                    <div class="remarks_parent">
                                      <div class="form-group remarks_child">
                                
                                        <div class="col-md-7">
                                          <textarea class="form-control" rows="3" formControlName="remark_title" required=""></textarea>
                                          <span class="text-danger"
                                            *ngIf="(remark.controls.remark_title?.touched || evaluvationFormSubmitted) && remark.controls.remark_title?.errors?.required">
                                            This field is required.
                                          </span>
                                        </div>
                                
                                        <div class="col-md-4">
                                          <select class="form-control" formControlName="remark_type" required="">
                                            <option value="1" selected="">{{ remarkLang['50'] }}</option>
                                            <option value="2">{{remarkLang['51']}}</option>
                                            <option value="3">{{ remarkLang['52'] }}</option>
                                          </select>
                                          <span class="text-danger" *ngIf="(remark.controls.remark_type?.touched || evaluvationFormSubmitted) && remark.controls.remark_type?.errors?.required">
                                            This field is required.
                                          </span>                                          
                                        </div>
                                
                                        <div class="col-md-1 fav-icons">
                                          <a href="javascript:void(0);" class=" common-newicons icon-colors3 remarks_action" (click)="deleteRemarks(i)">
                                            <span class="glyphicon glyphicon-trash"></span>
                                          </a>
                                        </div>
                                      </div>
                                    </div>                                
                                  </div>
                                </div>

                        
                        
                                <div class="form-senders confirm-bts">
                                  <input type="submit" value="Confirm" class="btn btn-success save_tab" (click)="saveEvaluvation(1)"  data-action="save" data-tab="">
                                  <input type="button" value="Confirm Next" class="btn btn-primary save_tab" (click)="saveEvaluvation(2)" data-action="save_next"
                                    data-tab="tab3">
                                </div>
                        
                        
                              </form>
                        
                            </div>
                        
                            <!-- Tab 3 content -->
                        
                            <div class="tab-pane" id="tab3">
                        
                              <form id="clause_manage_form2" [formGroup]="docsForm" method="post" class="form-horizontal" enctype="multipart/form-data" autocomplete="off">
                        
                                <div class="form-group">

                                      <div class="col-sm-12" formArrayName="timetable_link_uploaded">
                                        <div class="col-sm-3">
                                          <label>Attachments</label>
                                        </div>
                                        <div class="col-sm-8">
                                          <div class="form-group row" *ngFor="let link of docsForm?.get('timetable_link_uploaded')?.controls; let i = index;" [formGroupName]="i">
                                            <div class="col-sm-11">
                                              <input type="file" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)"
                                                formControlName="link">                          
                                            </div>
                                            <div class="col-sm-1">
                                              <button class="btn btn-primary pull-right" type="button" (click)="removeDocs(i)"
                                                *ngIf=" i!=(timetable_link_uploaded().controls.length-1) ">
                                                <i class="fa fa-trash-o"></i>
                                              </button>
                                              <button class="btn btn-primary pull-right" type="button" (click)="addDocs()"
                                                *ngIf=" i==(timetable_link_uploaded().controls.length-1) ">
                                                <i class="fa fa-plus"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="col-sm-12" formArrayName="audit_uploaded">
                                        <div class="col-sm-3">
                                        </div>
                                        <div class="col-sm-8">
                                        <div class="form-group row" *ngFor="let image of audit_uploaded().controls; let i=index">
                                          <div class="col-sm-11">
                                            <input type="hidden" class="form-control" formControlName="{{i}}">
                                            <input type="hidden" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">
                                            <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/deadline_image/{{image.value.split('/').pop()}}" target="_blank">{{image.value.split('/').pop()}}</a>
                                          </div>
                                          <div class="col-sm-1">
                                            <button class="btn btn-primary pull-right" type="button" (click)="removeAuditUploaded(i)">
                                              <i class="fa fa-trash-o"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                      </div>                                      

                                  <!-- <label>Attachments</label>
                        
                                  <div class="attachments_append">
                                    <div class="file_content">
                                      <div class="col-sm-11 paright" style="padding:0px">
                                        <div class="fileupload fileupload-new" data-provides="fileupload">
                                          <div class="input-group">
                                            <div class="form-control uneditable-input">
                                              <i class="fa fa-file fileupload-exists"></i>
                                              <span class="fileupload-preview" style="width:100%"></span>
                                            </div>
                                            <div class="input-group-btn">
                                              <div class="btn btn-light-grey btn-file">
                                                <span class="fileupload-new"><i class="fa fa-folder-open-o"></i> Select File</span>
                                                <span class="fileupload-exists"><i class="fa fa-folder-open-o"></i> Change</span>
                                                <input type="file" name="attachments[]" class="file-input add_more_file">
                                              </div>
                                              <a href="#" class="btn btn-light-grey fileupload-exists" data-dismiss="fileupload">
                                                <i class="fa fa-trash-o"></i> Remove </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-sm-1 paleft attachments_manage">
                                        <a href="javascript:void(0);" class="btn btn-default pull-right pull-rightnew attachments_add"><i
                                            class="fa fa-plus"></i></a>
                                      </div>
                                    </div>
                                    <textarea class="attachments_hidden_content" style="display:none"></textarea>
                                  </div> -->
                                </div>
                        
                        
                                <div class="form-senders confirm-bts">
                                  <input type="button" value="Confirm" class="btn btn-success save_tab" (click)="saveDocs()">
                                </div>

                              </form>
                            </div>
                        
                        
                        
                        
                          </div>
                        </div>
                      </div>                      
                    </div>
                  </div>

                  <div role="tabpanel" class="tab-pane"  [ngClass]="selectedTab === 'exord' ? 'active' : 'none'" id="reportTab">
                    <div class="row p-12">

                      <div class="col-sm-1">
                        <div class="social-icons">
    
                          <a class="plus-add" (click)="newaction(this.id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add" *ngIf="occinfo">
                            <i class="fa fa-plus"></i>
                          </a>
    
    
                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                              data-options="splash-2 splash-ef-4" title="Export">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>
                          
                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiViewDelete()" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>
    
                        </div>
                      </div>
                      
                      <div class="col-sm-3">
                        <a class="plus-add" (click)="showMailModal('mail_report')"  title="General Data">
                          <button class="btn btn-data">{{ lang?.send_mail }}</button>
                        </a>
                      <a class="plus-add" (click)="generate_report_pdf('audit_report')" title="Occurrence Details">
                        <button class="btn btn-data">{{ lang?.generate_report }}</button>
                      </a>
                      </div>

                      <div  class="col-sm-8">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="search"
                        type="text"
                        class="form-control"
                        [placeholder]="lang?.search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                        
    
                    </div>


                    <div class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions2" class="table-striped table-sm row-border hover"
                        id="table2" >
                        <thead>
                          <tr>
                            <th>No 123</th>
                            <th>{{ lang?.date_of_send }} </th>
                            <th>{{ lang?.sender }} </th>
                            <th>{{ lang?.recipients }}</th>
                            <th>{{ lang?.subject }} </th>
                            <th>{{ lang?.distribution_status }}</th>
                            <th>{{ lang?.attatchment }} </th>
                            <th>{{ lang?.action }} </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let edata of single_data?.output3?.mail_records; let i = index"
                            id="{{edata.mail_id}}">
                            <td>{{i+1}}</td>
                            <td>{{ edata.date_sent }}</td>
                            <td>{{ edata.sender }}</td>
                            <td>{{ edata.rec.join(', ') }}</td>
                            <td>{{ edata.subject }}</td>
                            <td>
                              <span [ngStyle]="{color:(edata.status == '1' ? 'green' : 'red' )}" ><i class="fa fa-circle" aria-hidden="true"></i></span>
                            </td>
                            <td> <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/audit/audit_report/{{ edata.attachments }}" target="_blank">{{ edata.attachments }}</a> </td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">

                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="edit_action"
                                      (click)="trigger_mail(edata.mail_id,this.id)"><i class="fa fa-envelope"></i>{{ lang?.mail
                                      }}</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action"
                                      (click)="delete(this.id,edata.mail_id)"><i class="fa fa-trash"></i>{{ exodlang?.erase }}</a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>


                        </tbody>

                      </table>
                    </div>


                  </div>


                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="generate_report_pdf" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.language_selection }}</h3>
      </div>

      <form>
        <div class="modal-body column_export">
          <div class="form-group">
            <label class="col-sm-3 control-label" for="form-field-3">{{ lang?.choose_lang }}</label>
            <div class="col-sm-8">
              <select class="form-control" [(ngModel)]="selectedLang" name="language_id">
                <option value="1">English</option>
                <option value="2">Italian</option>
              </select>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div id="datatableExportBtn1" class="export_dynamic_btn">
          </div>
          <button class="btn btn-success" (click)="create_report()">{{ lang?.save }}</button>
          <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
        </div>
      </form>

    </div>
  </div>
</div>

<div class="modal splash fade" id="show_mail_modal" tabindex="-1" role="dialog" aria-hidden="true">


  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.language_selection }}</h3>
      </div>

      <form [formGroup]="createMailForm" class="form-validation" (ngSubmit)="onMailSubmit()">
        <div class="modal-body">
          <input type="hidden" formControlName="type" />
          <div class="form-group row">
            <label class="col-sm-3 control-label" for="form-field-3">{{ lang?.sender }}</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" formControlName="sender">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 control-label" for="form-field-3">{{ lang?.recipients }}</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" formControlName="recipients">
              <span class="text-danger"
              *ngIf="(createMailForm.controls.recipients?.touched || createMailFormSubmitted) && createMailForm.controls.recipients?.errors?.required">
              This field is required.
            </span>              
            </div>
          </div>
          
          <div class="form-group row">
            <label class="col-sm-3 control-label" for="form-field-3">CC</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" formControlName="cc">
            </div>
          </div>
          
          <div class="form-group row">
            <label class="col-sm-3 control-label" for="form-field-3">{{ lang?.subject }}</label>
            <div class="col-sm-8">
              <input type="text" class="form-control" formControlName="subject">
            </div>
          </div>
          
          <div class="form-group row">
            <label class="col-sm-3 control-label" for="form-field-3">{{ lang?.text }}</label>
            <div class="col-sm-8">
              <textarea type="text" class="form-control" formControlName="message"></textarea>
              <span class="text-danger"
              *ngIf="(createMailForm.controls.message?.touched || createMailFormSubmitted) && createMailForm.controls.message?.errors?.required">
              This field is required.
            </span>                
            </div>
          </div>          

        </div>

        <div class="modal-footer">
          <button class="btn btn-success" type="submit">{{ lang?.send }}</button>
          <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
        </div>
      </form>

    </div>
  </div>
</div>

<div class="modal splash fade" id="odatatableExport3" tabindex="-1" role="dialog" aria-hidden="true"
  style="display: none;">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ odlang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <input type="hidden" name="scol_val" class="scol_val" value="">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export3_select_deselect_all($event)"><i></i> {{ odlang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ odlang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols3">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export3_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn3" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ odlang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ doclang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i> {{ doclang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ doclang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export3_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ doclang?.close }}</button>
      </div>

    </div>
  </div>
</div>
<div class="modal splash fade" id="datatableImport4" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ doclang?.dataImport }}</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a
                  href="http://vmi313621.contaboserver.net/Software_backend/uploads/documents.csv">{{
                  doclang?.downloadthecsvtemplate }}</a></font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ doclang?.save }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ doclang?.close }}</button>

      </div>
    </div>
  </div>
</div>

